export default __webpack_public_path__ + "static/media/restorent.59d8e095.svg";